import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

import type { Theme } from './update-theme.types'

const updateTheme = async (theme: Theme): Promise<void> => {
  await apiClient.patch('/v1/administration/profile/theme', { theme })
}

export const useUpdateTheme = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (theme: Theme) => updateTheme(theme),
    meta: {
      ...feedback,
    },
  })
}
